import React, { useState } from "react";
import { Modal, Tabs, Tooltip } from "antd";
import { useQuery } from "react-query";
import axios from "axios";
import { getImumXls } from "../../redux/Actions/imum_action_retail";
import ContentValidation from "../common/ContentValidation";

const { TabPane } = Tabs;

const RetailStatisticsModal = ({
  isModalVisible,
  handleCancel,
  logItemId,
  title,
  tabKey,
  setTabKey,
}) => {
  const [fetchedLogItem, setFetchedLogItem] = useState(null);
  const fetchLogItemById = async (id) => {
    const response = await axios.get(`/api/v1/retail_products/log_items/${id}`);
    return response.data;
  };

  const { isLoading } = useQuery(
    ["retailLogItem", logItemId],
    () => fetchLogItemById(logItemId),
    {
      enabled: !!logItemId,
      onSuccess: (data) => {
        setFetchedLogItem(data);
      },
      onError: (error) => {
        console.error(error, "Error fetching retail log item data");
      },
    }
  );

  const handleOk = () => {
    getImumXls({
      type: "get_log_xls",
      ids: [logItemId],
      filter: null,
    });
  };

  const handleTabChange = (key) => {
    setTabKey(key);
  };

  const errorsArray = fetchedLogItem?.errors ? [...fetchedLogItem.errors] : [];
  const exportArray = fetchedLogItem?.exports ? [...fetchedLogItem.exports] : [];

  return (
    <Modal
      title={title}
      open={isModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      width={"95vw"}
      cancelButtonProps={{ style: { display: "none" } }}
      okText="Download exports XLSX"
      bodyStyle={{ paddingTop: 0, paddingBottom: 0 }}
    >
      <Tabs
        defaultActiveKey={tabKey}
        activeKey={tabKey}
        style={{ paddingTop: -20 }}
        onChange={handleTabChange}
      >
        <TabPane
          tab={
            <div style={{ display: "flex", alignItems: "center" }}>
              Successful export
              <div
                className="text-xs text-center ml-1"
                style={{
                  backgroundColor: tabKey === "1" ? "#E6F7FF" : "#E0E0E0",
                  color: tabKey === "1" ? "#03B0F7" : "#00000073",
                  padding: "0px 9px",
                  borderRadius: 100,
                }}
              >
                {exportArray?.length}
              </div>
            </div>
          }
          key="1"
        >
          <ContentValidation loader={isLoading} array={fetchedLogItem?.exports || []}>
            <div style={{ overflowY: "auto", maxHeight: "60vh" }}>
              <table className="table">
                <thead>
                  <tr className="text-muted">
                    <th className="text-black">SKU</th>
                    <th className="text-black">MPN</th>
                    <th className="text-black">EAN</th>
                    <th className="text-black">Prod. title</th>
                    <th className="text-black">Prod. cat.</th>
                    <th className="text-black">Brand</th>
                    <th className="text-black no-wrap">Exported price</th>
                    <th className="text-black">Cheapest competitor</th>
                    <th className="text-black">Min market price</th>
                    <th className="text-black">Department</th>
                  </tr>
                </thead>
                <tbody>
                  {fetchedLogItem?.exports.map((item, index) => (
                    <tr className="align-middle tableColumn" key={item?.sku + index}>
                      <td className="align-middle">{item?.sku}</td>
                      <td className="align-middle">
                        {item?.mpn ? (
                          <Tooltip title={item?.mpn}>
                            {`${item?.mpn?.slice(0, 3)}...${item?.mpn?.slice(-3)}`}
                          </Tooltip>
                        ) : (
                          "-"
                        )}
                      </td>
                      <td className="align-middle">
                        {item?.ean ? (
                          <Tooltip title={item?.ean}>
                            {`${item?.ean?.slice(0, 3)}...${item?.ean?.slice(-3)}`}
                          </Tooltip>
                        ) : (
                          "-"
                        )}
                      </td>
                      <td className="align-middle">{item?.title}</td>
                      <td className="align-middle">{item?.category}</td>
                      <td className="align-middle">{item?.brand}</td>
                      <td className="align-middle">{item?.price ? item.price : "-"}</td>
                      <td className="align-middle">{item?.min_shop ? item.min_shop : "-"}</td>
                      <td className="align-middle">{item?.min_price ? item.min_price : "-"}</td>
                      <td className="align-middle">{item?.department || "-"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </ContentValidation>
        </TabPane>
        <TabPane
          tab={
            <div style={{ display: "flex", alignItems: "center" }}>
              Unsuccessful export
              <div
                className="text-xs text-center ml-1"
                style={{
                  backgroundColor: tabKey === "2" ? "#E6F7FF" : "#E0E0E0",
                  color: tabKey === "2" ? "#03B0F7" : "#00000073",
                  padding: "0px 9px",
                  borderRadius: 100,
                }}
              >
                {errorsArray?.length}
              </div>
            </div>
          }
          key="2"
        >
          <ContentValidation loader={isLoading} array={fetchedLogItem?.errors || []}>
            <div style={{ overflowY: "auto", maxHeight: "60vh" }}>
              <table className="table">
                <thead>
                  <tr className="text-muted">
                    <th className="text-black">SKU</th>
                    <th className="text-black">MPN</th>
                    <th className="text-black">EAN</th>
                    <th className="text-black">Prod. title</th>
                    <th className="text-black">Prod. cat.</th>
                    <th className="text-black">Brand</th>
                    <th className="text-black no-wrap">Export price</th>
                    <th className="text-black">Cheapest competitor</th>
                    <th className="text-black">Min market price</th>
                    <th className="text-black">Department</th>
                    <th className="text-black">Failure</th>
                  </tr>
                </thead>
                <tbody>
                  {fetchedLogItem?.errors?.map((item, index) => (
                    <tr className="align-middle tableColumn" key={item?.sku + index}>
                      <td className="align-middle">{item?.sku}</td>
                      <td className="align-middle">
                        {item?.mpn ? (
                          <Tooltip title={item?.mpn}>
                            {`${item?.mpn?.slice(0, 3)}...${item?.mpn?.slice(-3)}`}
                          </Tooltip>
                        ) : (
                          "-"
                        )}
                      </td>
                      <td className="align-middle">
                        {item?.ean ? (
                          <Tooltip title={item?.ean}>
                            {`${item?.ean?.slice(0, 3)}...${item?.ean?.slice(-3)}`}
                          </Tooltip>
                        ) : (
                          "-"
                        )}
                      </td>
                      <td className="align-middle">{item?.title}</td>
                      <td className="align-middle">{item?.category}</td>
                      <td className="align-middle">{item?.brand}</td>
                      <td className="align-middle ">{item?.price ? item.price : "-"}</td>
                      <td className="align-middle">{item?.min_shop ? item.min_shop : "-"}</td>
                      <td className="align-middle">{item?.min_price ? item.min_price : "-"}</td>
                      <td className="align-middle">{item?.department || "-"}</td>
                      <td className="align-middle">{item?.error}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </ContentValidation>
        </TabPane>
      </Tabs>
    </Modal>
  );
};

export default RetailStatisticsModal;
